export const NewExerciseTag = () => {
  return (
    <div className='flex bg-tGreen rounded-md px-2 py-[1px] items-center justify-center z-[1] ml-3'>
      <p className='text-white text-sm'>New</p>
    </div>
  )
}
